import { emptyDdrDraft, emptyDirectDraft, emptyRoutingRowDraft, emptyUpdateDraft } from '@/utils/mapperConfigDraft';
import MapperValueSpecChip from './MapperValueSpecChip.vue';
export default {
  name: 'MapperEmitRuleCard',
  components: {
    MapperValueSpecChip
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    shape: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    captures: {
      type: Array,
      required: false,
      default: () => []
    },
    lookupTables: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    activeOutput() {
      return this.value[this.shape];
    },
    hasInactiveOutput() {
      return Boolean(this.value[this.shape === 'direct' ? 'ddr' : 'direct']);
    },
    routingSources() {
      return ['fields', 'value'];
    }
  },
  methods: {
    setForeach(next) {
      this.value.foreach = next === null || next === undefined ? '' : next;
      this.$emit('change');
    },
    setOn(target, field, next) {
      target[field] = next;
      this.$emit('change');
    },
    createOutput() {
      this.value[this.shape] = this.shape === 'ddr' ? emptyDdrDraft() : emptyDirectDraft();
      this.$emit('change');
    },
    addUpdate() {
      this.value.direct.updates.push(emptyUpdateDraft());
      this.$emit('change');
    },
    removeUpdate(updateIndex) {
      this.value.direct.updates.splice(updateIndex, 1);
      this.$emit('change');
    },
    setRoutingSource(source) {
      if (!source) {
        return;
      }
      this.value.ddr.routingSource = source;
      this.$emit('change');
    },
    setRoutingName(row, next) {
      row.name = next === null || next === undefined ? '' : next;
      this.$emit('change');
    },
    addRoutingRow() {
      this.value.ddr.routingRows.push(emptyRoutingRowDraft());
      this.$emit('change');
    },
    removeRoutingRow(rowIndex) {
      this.value.ddr.routingRows.splice(rowIndex, 1);
      this.$emit('change');
    }
  }
};